const { ConsentMode } = require('@deliveroo/cookies-consent');

const getCookiesConsentMode = () =>
  process.env.NODE_ENV === 'production' ? ConsentMode.DEFAULT : ConsentMode.NOOP;

module.exports = {
  getCookiesConsentMode,
};
